import React from 'react';

export default function renderIcon({
  width = 18,
  height = 15,
  color = '#4E5B7E',
}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="30.414" viewBox="0 0 28 30.414">
      <g id="Group_75623" data-name="Group 75623" transform="translate(-1301 -350.586)">
        <text id="close" transform="translate(1301 376)" fill="#6f8595" fontSize="12" fontFamily="Kanit-Light, Kanit" fontWeight="300"><tspan x="0" y="0">close</tspan></text>
        <g id="Group_75615" data-name="Group 75615" transform="translate(12777.5 20299.5)">
          <g id="Group_75613" data-name="Group 75613" transform="translate(-11467.5 -19947.5)">
            <line id="Line_5791" data-name="Line 5791" y1="9.832" x2="9.832" fill="none" stroke="#6f8595" strokeLinecap="round" strokeWidth="2" />
            <line id="Line_5792" data-name="Line 5792" x1="9.832" y1="9.832" fill="none" stroke="#6f8595" strokeLinecap="round" strokeWidth="2" />
          </g>
        </g>
      </g>
    </svg>
  );
}
